import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconTrophyFilled = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={11}
    fill="none"
    viewBox="0 0 13 11"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FFDD56"
      d="M12.38 2.371c0 .059.371 1.66-.703 3.184-.742 1.093-1.972 1.855-3.672 2.304A.838.838 0 0 0 8.24 9.5h.097a.95.95 0 0 1 .938.938c0 .175-.117.312-.293.312H4.626c-.156 0-.293-.137-.293-.313 0-.507.41-.937.938-.937h.078c.469 0 .86-.371.84-.84a.815.815 0 0 0-.606-.8c-1.699-.45-2.93-1.212-3.652-2.305C.896 4.03 1.267 2.43 1.267 2.37A.499.499 0 0 1 1.736 2h1.972c-.019-.234-.019-.45 0-.645 0-.332.274-.605.625-.605h4.981c.352 0 .625.273.625.605.02.196.02.41 0 .645h1.973c.214 0 .41.156.468.371ZM2.712 5.047c.45.683 1.172 1.21 2.13 1.601-.723-1.132-1.016-2.539-1.133-3.71H2.146c-.02.468.02 1.308.566 2.109Zm8.223 0c.547-.8.586-1.64.566-2.11H9.94c-.117 1.172-.41 2.579-1.133 3.711.957-.39 1.68-.918 2.13-1.601Z"
    />
  </svg>
));
export default SvgIconTrophyFilled;
